import {sliderOpt} from 'src/app/shared/data';

export const introSlider = {
    ...sliderOpt,
    nav: false,
    loop: true,
};
export const introSlider1 = {
    ...sliderOpt,
    nav: false,
    loop: true,
};

export const brandSlider = {
    ...sliderOpt,
    nav: false,
    dots: false,
    margin: 0,
    loop: false,
    responsive: {
        0: {
            items: 2
        },
        420: {
            items: 3
        },
        600: {
            items: 4
        },
        900: {
            items: 5
        },
        1024: {
            items: 6
        },
        1360: {
            items: 7,
            nav: true,
            dots: true
        }
    }
};

export const specialSlider = {
    ...sliderOpt,
    nav: false,
    dots: true,
    margin: 20,
    loop: false,
    responsive: {
        0: {
            items: 2
        },
        480: {
            items: 2
        },
        768: {
            items: 3
        },
        992: {
            items: 4
        },
        1200: {
            items: 5
        },
        1600: {
            items: 6,
            nav: true
        }
    }
};

export const blogSlider = {
    ...sliderOpt,
    nav: false,
    dots: true,
    items: 3,
    margin: 20,
    loop: false,
    responsive: {
        0: {
            items: 1
        },
        576: {
            items: 2
        },
        992: {
            items: 3
        }
    }
};


export const offering = [
    {
        button_link: '/exclusive',
        image: 'assets/images/home/offering/exclusive.jpg',
        mobile_image: 'assets/images/home/offering/exclusive.jpg',
        title: 'Indiapicture Exclusive',
    },
    {
        // Relative, like every other internal link in this file. It was
        // absolute to https://indiapicture.com, so the mirror build's home page
        // sent visitors to the production studio.
        button_link: '/ai',
        image: 'assets/images/home/offering/indiapicture_ai.jpg',
        mobile_image: 'assets/images/home/offering/indiapicture_ai.jpg',
        title: 'Indiapicture AI',

    },
    {
        button_link: 'https://studioip.in',
        image: 'assets/images/home/offering/studioip.jpg',
        mobile_image: 'assets/images/home/offering/studio_ip.jpg',
        title: 'Studio IP',
    },
    {
        button_link: '#',
        image: 'assets/images/home/offering/custom_brief.jpg',
        mobile_image: 'assets/images/home/offering/custom_brief.jpg',
        title: 'Custom Brief',
    }
];
